import Element from "./index";
import { RouteType } from "routes/types";

const route: RouteType = {
  id: 1310,
  parentId: 1300,
  name: "Team",
  label: "ESET Team",
  path: "/",
  icon: "people",
  element: Element,
  footer: true,
  user: false,
  admin: false,
  hidden: false,
};

export default route;
